export default __webpack_public_path__ + "static/media/rain-probality.b7a9b35c.svg";